/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ReservationPinType = 'PER_RESERVATION' | 'PER_PROPERTY' | 'NOT_APPLICABLE';

export const ReservationPinType = {
    PERRESERVATION: 'PER_RESERVATION' as ReservationPinType,
    PERPROPERTY: 'PER_PROPERTY' as ReservationPinType,
    NOTAPPLICABLE: 'NOT_APPLICABLE' as ReservationPinType
};

